import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";
import WebSchedulingHeading from "@components/Booking/Heading";
import React from "react";

const HeadingWithoutReason = () => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  return (
    <WebSchedulingHeading>
      {i18n.t("Select a location", {ns: "web-scheduling"})}
    </WebSchedulingHeading>
  );
};
export default React.memo(HeadingWithoutReason);
